import { CallApi, handleJSONResponse } from "./common";
import SimpleArtist from "../../../../common/types/artist/simple-artist";
import { ArtistSearchResponse } from "../../../../services/artist/types/artist-search-response";
import { ArtistInviteEvent } from "../../../../services/artist/types/artist-invite-event";

const callAPI = CallApi("artists");

export const getArtistsInfo = async (
  artistId: string
): Promise<SimpleArtist> => {
  const response = await callAPI(`/${artistId}`, "GET");

  return await handleJSONResponse(response);
};

export const verifyArtist = async (
  artistId: string
): Promise<{ verified: boolean }> => {
  const response = await callAPI(`/admin/verify`, "POST", { artistId });

  return await handleJSONResponse(response);
};

export const getArtistsInfoTeam = async (artistId: string): Promise<any> => {
  const response = await callAPI(`/${artistId}/team`, "GET");

  return await handleJSONResponse(response);
};

export const blockArtist = async (
  artistId: string,
  takedown: boolean
): Promise<void> => {
  await callAPI(`/admin/${artistId}`, "DELETE", { takedown });
};

export const signIn = async (
  artistId: string
): Promise<{
  loginUrl: string;
}> => {
  const response = await callAPI(`/admin/login`, "POST", { artistId });
  return handleJSONResponse(response);
};

export const searchExternalArtists = async (
  query: string
): Promise<ArtistSearchResponse> => {
  const response = await callAPI("/search", "GET", { q: query });

  return handleJSONResponse(response);
};

export const inviteArtist = async (
  request: ArtistInviteEvent
): Promise<SimpleArtist> => {
  const response = await callAPI("/invite", "POST", request);

  return handleJSONResponse(response);
};
